'use client'

import { useCart } from '@/lib/hooks'
import { cn } from '@/lib/utils'

import { ProductCardMini } from '@/components/molecules'

interface CartItemProps extends React.ComponentPropsWithoutRef<'div'> {
  product: Product
  onClick?: () => void
  className?: string
  isOnPreview?: boolean
}

export const CartItem = ({
  product,
  onClick,
  className,
  isOnPreview,
}: CartItemProps) => {
  const { selectProduct } = useCart()

  return (
    <div className={cn('relative flex w-full rounded-lg', className)}>
      <div className="relative z-10 w-full cursor-pointer select-none">
        <ProductCardMini
          onClick={onClick ? onClick : () => selectProduct(product)}
          product={product}
          isOnPreview={isOnPreview ?? false}
        />
      </div>
    </div>
  )
}
